module.exports = __webpack_public_path__ + "static/Lato-Black-f80bda6afd19534368443a3d0323a140.woff";